import { render, staticRenderFns } from "./testDettaglio.vue?vue&type=template&id=1cf44ef4"
import script from "./testDettaglio.vue?vue&type=script&lang=js"
export * from "./testDettaglio.vue?vue&type=script&lang=js"
import style0 from "./testDettaglio.vue?vue&type=style&index=0&id=1cf44ef4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports